import { Pipe, PipeTransform } from "@angular/core";
import { DateTime } from "luxon";

@Pipe({
    name: "isoToDate",
    standalone: false
})
export class IsoToDatePipe implements PipeTransform {
    public transform(dateIso: string, showTimeOfDay: boolean = false, timeZone: string = "utc"): string {
        const dateTime = DateTime.fromISO(dateIso, {
            zone: timeZone
        }).toLocal();
        const formattedDate: string = dateTime.toFormat("D");
        if (showTimeOfDay) return `${formattedDate} at ${dateTime.toFormat("t")}`;
        return formattedDate;
    }
}
